import React, { useEffect, useState } from "react";
import { Sidebar } from './components/sidebar';
import { Topbar } from './components/topbar';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store } from './store'
import CheckLogin from './components/check-login';
import { UserBar } from './components/userbar';
import { TourProvider } from "@reactour/tour";
import steps from "./components/tour/steps";


export default function Root() {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isTablet, setIsTablet] = useState(window.innerWidth < 992 && window.innerWidth > 768);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const onCollapseButtonClick = () => {
        setSidebarCollapsed(!sidebarCollapsed);
    }

    const onMobileMenuClick = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    }

    const handleResize = () => {
        setIsTablet(window.innerWidth < 992 && window.innerWidth > 768);
    }

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array ensures this runs only on mount and unmount

    const location = useLocation();

    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location])



    return (
        <Provider store={store}>
            {/* <TourProvider
                steps={steps}
            > */}

                <CheckLogin />
                {/* 
                Hide the userbar if we're on the new subscription page.
             */}
                {!location.pathname.includes('subscriptions/new') &&
                    <UserBar />
                }
                <div className={`wrapper ${sidebarCollapsed || isTablet ? 'sidebar-collapsed' : ''} ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
                    <Sidebar collapsed={sidebarCollapsed} collapseHandler={onCollapseButtonClick} />
                    <Topbar collapseHandler={onMobileMenuClick} />
                    <div className="main">
                        <Outlet />
                    </div>
                </div>
            {/* </TourProvider> */}
        </Provider >
    );
}